import cn from 'clsx'
import React from 'react'

import { FILE, PLAYLIST, TRACK } from '@disco/constants/ItemTypes'

import type { Group } from 'types/group'

import { dndConnectRef } from 'utils/dnd-connect-ref'

import { DropFilesIndicator } from 'components/ui/drop-indicator'

import { useGroupDrop } from './CustomGroupDropWrapper'

// No GROUP: folder/channel reordering and reparenting stay row and sidebar
// interactions; a pane body must never receive them.
export const GROUP_PANE_ACCEPTED_TYPES = [TRACK, PLAYLIST, FILE]

type Props = {
  group: Group
  children: React.ReactNode
}

/**
 * Makes an open folder/channel column a drop target for its own group, so
 * tracks, playlists and OS files can be dropped anywhere in the pane —
 * including empty space — instead of only on a folder row. Shares
 * CustomGroupDropWrapper's drop spec, so placement semantics are identical;
 * row targets inside the pane still win via monitor.didDrop().
 */
export default function GroupPaneDropWrapper({ group, children }: Props) {
  const [{ draggedItem, isDropHovered }, dropRef] = useGroupDrop(
    group,
    GROUP_PANE_ACCEPTED_TYPES,
  )

  return (
    <div
      ref={dndConnectRef(dropRef)}
      className={cn('PaneBodyDropTarget', { 'is-over': isDropHovered })}
    >
      {children}
      {isDropHovered && draggedItem?.files && <DropFilesIndicator />}
    </div>
  )
}
